import { Etablissement } from '@/models/Etablissement';

export interface EtabState {
    listEtablissements : Array<Etablissement>;
    currentEtab : Etablissement ;
}
export enum ETAB_STORE {
SET_LIST_ETAB = "SET_LIST_ETAB",
SET_CURRENT_ETAB = "SET_CURRENT_ETAB"
}